import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import RadialSeparators from "./RadialSeparators";

export const calculateClaimProgress = (totalClaims) => {
  const completedCycles = totalClaims % 6; // This will give us how many claims in the current cycle
  const progressPercentage = (completedCycles / 6) * 100;

  let claimsText = `${completedCycles} claims out of 6 completed`;

  if (totalClaims >= 6) {
    claimsText = `Cycle completed! Resetting back to 1st claim.`;
  }

  return {
    progressPercentage,
    claimsText,
  };
};


const Feedback = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("+91");
  const [location, setLocation] = useState("");
  const [feedback, setFeedback] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [productId, setProductId] = useState(null); // State to store productId
  const [beverageType, setBeverageType] = useState(null); // State to store beverage type
  const [batchNumber, setBatchNumber] = useState(null); // State to store badge number
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [totalClaims, setTotalClaims] = useState(null);
  const [claimProgress, setClaimProgress] = useState(0); // To track claim progress
  const [claimsText, setClaimsText] = useState(""); // To show claims information
  const [totalEnergySaved, setTotalEnergySaved] = useState(0);
  const [claimResult, setClaimResult] = useState(null);

  const locationObj = useLocation();

  // useEffect(() => {
  //   if (totalClaims) {
  //     const { progressPercentage, claimsText } = calculateClaimProgress(totalClaims);
  //     setClaimProgress(progressPercentage);
  //     setClaimsText(claimsText);
  //   }
  // }, [totalClaims]);
  useEffect(() => {
    // Extract productId from the query parameters
    const urlParams = new URLSearchParams(locationObj.search);
    const id = urlParams.get("productId"); // Get productId from the URL
    const type = urlParams.get("beverageType"); // Get beverage type from the URL
    const batchNumber = urlParams.get("batchNumber"); // Get beverage type from the URL
    if (id && batchNumber) {
      setProductId(id); // If productId is found, set it to state
      setBeverageType(type);
      setBatchNumber(batchNumber);
    } else {
      setErrorMessage("Invalid QR code scanned. No product ID found.");
    }
  }, [locationObj]);

  useEffect(() => {
    const isValid = name !== "" && phone.length === 13 && typeof location === "object";
    setIsFormValid(isValid);
  }, [name, phone, location]);

  const handleLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({
            latitude,
            longitude,
          });
        },
        (error) => {
          console.error(error);
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.error("User denied the request for Geolocation. Using fallback.");
              fetchFallbackLocation();
              break;
            case error.POSITION_UNAVAILABLE:
              console.error("Location information is unavailable.");
              toast.error("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              console.error("The request to get user location timed out.");
              toast.error("Location request timed out.");
              break;
            default:
              console.error("An unknown error occurred.");
              toast.error("An unknown error occurred.");
              break;
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      toast.error("Geolocation is not supported by this browser.");
      setLocation("Geolocation is not supported by this browser.");
    }
  };

  // Fallback solution using IP-based geolocation
  const fetchFallbackLocation = () => {
    fetch("https://ipinfo.io/json?token=9faeaaa20f1fd9") // Replace YOUR_API_TOKEN with a valid token from ipinfo.io
      .then((response) => response.json())
      .then((data) => {
        const [latitude, longitude] = data.loc.split(",");
        window.alert(`Fallback Latitude: ${latitude}, Longitude: ${longitude}`);
        setLocation({
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude),
        });
        toast.success("Location detected using fallback method.");
      })
      .catch((error) => {
        console.error("Error using fallback geolocation:", error);
        setLocation("Unable to retrieve location.");
        toast.error("Failed to retrieve location using fallback method.");
      });
  };


  const handlePhoneChange = (e) => {
    const phoneValue = `+91${e.target.value}`;
    setPhone(phoneValue);
    if (e.target.value.length !== 10 || !/^\d{10}$/.test(e.target.value)) {
      setPhoneError("Phone number must be 10 digits.");
    } else {
      setPhoneError("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phoneError) {
      alert("Please fix the errors before submitting.");
      return;
    }
    const data = {
      name,
      email,
      phoneNumber: phone,
      latitude: location.latitude,
      longitude: location.longitude,
      feedback,
      productId,
      beverageType,
      batchNumber
    };
    fetch("https://prophel.in/process-claim", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("Success:", result);

        if (result.error) {
          toast.error(result.error);
        } else if (result.success) {
          toast.success(`Cashback Rs.${result.cashback_amount} Processed Successfully!`);
          setTotalClaims(result.total_claims);
          setClaimResult(result);
        }

      })
      .catch((error) => {
        console.error("Error:", error);
        toast.success("Cashback Processed Successfully!");
      });

    console.log("Feedback Submitted: ", data);
    // Clear form after submission
    setName("");
    setEmail("");
    setPhone("+91");
    setFeedback("");
    setLocation("");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-50">
      <div className="w-full max-w-lg p-6 bg-white rounded-lg shadow-md">

        {errorMessage && (
          <div className="mb-4 text-sm text-red-500 text-center">{errorMessage}</div>
        )}
        {totalClaims ? (
          <div className="flex flex-col items-center justify-center">
            {/* <h3 className="text-xl font-bold text-center text-gray-700 mb-4">Your Cashback Claim</h3>
            <CircularProgressbar
              value={claimProgress}
              text={`${claimProgress.toFixed(0)}%`} // Show percentage
              strokeWidth={10}
              styles={{
                path: {
                  stroke: claimProgress === 100 ? '#4caf50' : '#f44336', // Green if 100%, Red if not
                },
                text: {
                  fill: '#333',
                  fontSize: '16px',
                },
              }} */}
            <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
              Together, we’re creating change — Thank You for supporting sustainability and reducing waste!
            </h2>
            <div className="flex items-center space-x-6 mb-4">
              <div className="w-32 h-32">
                <CircularProgressbarWithChildren
                  value={claimResult.goal_percentage}
                  text={`${claimResult.goal_percentage}%`} // Show percentage as text
                  strokeWidth={10}
                  styles={buildStyles({
                    strokeLinecap: "butt",
                    pathColor: claimResult.goal_percentage >= 1 ? "#4caf50" : "#f44336", // Green if target achieved, Red otherwise
                    textColor: "#333",
                    trailColor: "#ddd",
                  })}
                >
                  <RadialSeparators
                    count={12}
                    style={{
                      background: "#fff",
                      width: "2px",
                      // This needs to be equal to props.strokeWidth
                      height: `${10}%`
                    }}
                  />
                </CircularProgressbarWithChildren>
              </div>
              <div className="text-center">
                <p className="text-lg text-gray-600">
                  <strong>Target:</strong> 25 Kg
                </p>
                <p className="text-lg text-gray-600">
                  <strong>Achieved till now:</strong> {(claimResult.total_food_waste_saved / 1000).toFixed(3)} Kg
                </p>
              </div>
              <div>
                {/* <p className="text-lg text-gray-600">
                  Your contribution in this scan: <strong>{claimResult.food_waste_saved_this_scan} grams</strong>
                </p> */}
                {/* <p className="text-sm text-gray-500">
                  Total Progress Towards Target: <strong>{claimProgress.toFixed(0)}%</strong>
                </p> */}
              </div>
            </div>
            <p className="text-lg text-gray-600 mb-4">
              YAY! You contributed to reduction of <strong>{claimResult.food_waste_saved_this_scan} grams</strong> of food waste which is {(claimResult.food_waste_saved_this_scan / 25000) * 100}% of our target <strong>25Kg</strong>
            </p>

            <p className="text-lg text-green-600 font-semibold mb-4">
              Congratulations! You've earned a cashback of <strong>Rs. {claimResult.cashback_amount}</strong> for your contribution to reducing food waste. Keep up the great work and earn more rewards!
            </p>

            {/* Certificate URL Section */}
            {claimResult.certificateUrl && (
              <div className="mt-6">
                <p className="text-lg text-gray-600 mb-4">
                  Would you like to view the quality certificate ?
                </p>
                <a
                  href={claimResult.certificateUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                >
                  View Certificate
                </a>
              </div>
            )}
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
              Feedback Form
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Name Field */}
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-600">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter your name"
                  required
                  className="w-full px-4 py-2 mt-1 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Email Field */}
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-600">
                  Email (Optional)
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full px-4 py-2 mt-1 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Phone Number Field */}
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-600">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center">
                  <span className="px-3 py-2 bg-gray-100 border border-r-0 rounded-l-md">
                    +91
                  </span>
                  <input
                    id="phone"
                    type="tel"
                    value={phone.slice(3)}
                    onChange={handlePhoneChange}
                    placeholder="Enter phone number"
                    required
                    pattern="\d{10}"
                    className="flex-1 px-4 py-2 border rounded-r-md focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                {phoneError && (
                  <p className="mt-2 text-sm text-red-500">{phoneError}</p>
                )}
              </div>

              {/* Location Field */}
              <div>
                <label className="block text-sm font-medium text-gray-600">
                  Location <span className="text-red-500">*</span>
                </label>
                <button
                  type="button"
                  onClick={handleLocation}
                  className="px-4 py-2 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Detect Current Location
                </button>
                {typeof location === "object" && (
                  <p className="mt-2 text-sm text-gray-500">
                    <strong>Detected Location:</strong> Latitude: {location?.latitude}, Longitude: {location?.longitude}
                  </p>
                )}
                {typeof location === "string" && (
                  <p className="mt-2 text-sm text-red-500">{location}</p>
                )}
              </div>

              {/* Feedback Field */}
              <div>
                <label htmlFor="feedback" className="block text-sm font-medium text-gray-600">
                  Feedback
                </label>
                <textarea
                  id="feedback"
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  placeholder="Share your feedback"
                  rows="4"
                  required
                  className="w-full px-4 py-2 mt-1 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={!isFormValid || errorMessage}
                className={`w-full px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none ${isFormValid ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-400 cursor-not-allowed'}`}
              >
                Submit Feedback and Claim Cashback
              </button>
            </form>
          </>
        )}

      </div>
    </div>
  );
};

export default Feedback;
